import { ORGANISATION_TYPES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(ORGANISATION_TYPES_ENDPOINT);
export default instance;
